<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.contratos')} / ${$t('menu.flights')}`"
      >
        <ContrateFlightsList></ContrateFlightsList>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import ContrateFlightsList from './tablas/ContrateFlightsList.vue'

export default {
  components: {
    AppCardCode,
    ContrateFlightsList,
  },
}
</script>
